import React from 'react';
import WorkplaceSettings from './WorkplaceSettings';
import styles from './GeneralSettings.module.scss';
import OrganisationSettings from './OrganisationSettings';
import UserSettings from './UserSettings';
import OrganizationalHierarchySettings from './OrganisationHierarchy';
import SecurityRoles from './SecurityRoles';
import PartnerSettings from './PartnerSettings';
import usePermissionCheck from '../../../../core/hooks/usePermissionCheck';

type GeneralSettingsProps = {
	inFocus: 'organization' | 'workplace' | 'user' | 'organizational_hierarchy' | 'security_role' | 'partners' | null;
	setInFocus: (focus: 'organization' | 'workplace' | 'user' | 'organizational_hierarchy' | 'security_role' | 'partners' | null) => void;
};

const GeneralSettings: React.FC<GeneralSettingsProps> = ({ inFocus, setInFocus }) => {
	const { hasViewPermission } = usePermissionCheck();
	
	const canViewOrganization = hasViewPermission('Organization');
	const canViewWorkplace = hasViewPermission('Workplace');
	const canViewUser = hasViewPermission('User');
	const canViewHierarchy = hasViewPermission('Hierarchy');
	const canViewSecurityRoles = hasViewPermission('Security Roles');
	const canViewPartners = hasViewPermission('Partner');
	const handleFocusChange = (
		focus:
			| 'organization'
			| 'workplace'
			| 'user'
			| 'organizational_hierarchy'
			| 'security_role'
			| 'partners'
			| null
	) => {
		setInFocus(focus);
	};

	return (
		<div className={styles.generalSettingsContainer}>
			{canViewOrganization && (inFocus === null || (inFocus && inFocus === 'organization')) && (
				<OrganisationSettings handleFocusChange={handleFocusChange} />
			)}
			{canViewWorkplace && (inFocus === null || (inFocus && inFocus === 'workplace')) && (
				<WorkplaceSettings handleFocusChange={handleFocusChange} inFocus={inFocus} />
			)}
			{canViewUser && (inFocus === null || (inFocus && inFocus === 'user')) && (
				<UserSettings handleFocusChange={handleFocusChange} />
			)}
			{canViewHierarchy && (inFocus === null || (inFocus && inFocus === 'organizational_hierarchy')) && (
				<OrganizationalHierarchySettings handleFocusChange={handleFocusChange} inFocus={inFocus} />
			)}
			{canViewSecurityRoles && (inFocus === null || (inFocus && inFocus === 'security_role')) && (
				<SecurityRoles handleFocusChange={handleFocusChange} inFocus={inFocus} />
			)}
			{canViewPartners && (inFocus === null || (inFocus && inFocus === 'partners')) && (
				<PartnerSettings handleFocusChange={handleFocusChange} />
			)}
		</div>
	);
};

export default GeneralSettings;
